import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { FooterComponent } from 'src/app/layouts/full/footer/footer.component';
import { AppTopstripComponent } from 'src/app/layouts/full/top-strip/topstrip.component';
import { MaterialModule } from 'src/app/material.module';
import { DEFAULT_AUTHENTICATED_ROUTES } from 'src/app/permissions/rbac-policy';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
  selector: 'app-error-page',
  standalone: true,
  imports: [MaterialModule, RouterModule, FooterComponent, AppTopstripComponent],
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss'],
})
export class ErrorPageComponent implements OnInit, OnDestroy {
  type: 'unauthorized' | 'notfound' = 'notfound';
  countdown = 5;
  redirectUrl = '/home';
  private redirectTimer: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    // Get error type
    const dataType = this.route.snapshot.data['type'];
    this.type = dataType === 'unauthorized' ? 'unauthorized' : 'notfound';

    // ---------- FIXED ROLE REDIRECTION ----------
    if (this.authService.isLoggedIn()) {
      const role = this.authService.getUserRole();

      this.redirectUrl = DEFAULT_AUTHENTICATED_ROUTES[role as keyof typeof DEFAULT_AUTHENTICATED_ROUTES] || '/home';
    } else {
      this.redirectUrl = '/home'; // Not logged in → send to home
    }

    // Countdown auto-redirect
    this.redirectTimer = setInterval(() => {
      this.countdown--;
      if (this.countdown <= 0) {
        clearInterval(this.redirectTimer);
        this.router.navigate([this.redirectUrl]);
      }
    }, 1000);
  }

  ngOnDestroy(): void {
    if (this.redirectTimer) {
      clearInterval(this.redirectTimer);
    }
  }

  goHome(): void {
    this.router.navigate([this.redirectUrl]);
  }
}
